import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FilterUtils } from 'primeng/components/utils/filterutils';
import 'rxjs/operator/map';
import { CommonSerivce } from '../shared/services/common.service';
import { UserService } from '../shared/services/user.service';
import { ConfirmationService } from 'primeng/api';
import { jsPDF } from "jspdf";
//import * as jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Observable } from 'rxjs/Observable';
//import 'jspdf-autotable';
//import jsPDF from 'jspdf';
//import 'jspdf-autotable';
import 'rxjs/Rx';
import * as XLSX from "xlsx-js-style";

@Component({
  selector: 'listValue',
  styleUrls: ['../shared/share.component.css'],
  providers: [CommonSerivce, UserService, DatePipe, ConfirmationService],
  templateUrl: './listValue.component.html'
})

export class ListValueComponent implements OnInit {

  /*
        RecordList - Search result list
        SelectedRecordList - User selected record (Multiple) in the result table
        SelectedRecord - User selected record (Single) for edition
  */
  public RecordList: IListValue[];
  public SelectedRecordList: IListValue[];
  public SelectedRecord: IListValue;
  public InputErrorMsg: Message[] = [];

  //  Hold the value of the user inputted search field, to be used for searching
  public SearchFieldHolder: any;
  public SearchDnFieldHolder: any;
  public cols: any;
  public exportColumns: any;
  public pdfColumns = [];
  public attachmentCols: any;

  //  Code value list for List Box, add required code value list
  public DomainList: IDomainValue[];
  public DataRoleList: IDataRole[];
  public ProcessRoleList: IListValue[];
  public ListCodeList: IListValue[];

  public loggedInUserAccountType: string = "";
  public loggedInCompanyCode: string = "";

  public globalFilterValue1: string = "";
  public globalFilterValue2: string = "";
  public globalFilterValue3: string = "";


  //excel variable
  excelRow: string[] = [];
  strLine: string;
  cellList: string[];
  lastRowNumber: number;


  /*
        sort0 - define the sorting sequence for the table field (1 asc, 0 desc)
        softF - define the sorting field name
  */
  sortO: number = 0;
  sortF: string = '';


  /*
        Major control variables
            FormTitle - Initial Form Title for the landing form
            PrimaryApiPath - Path for the API controller per component 
            ShowEditForm/ ShowAddForm - control whether to show Inquiry or Edit form
            AutoReload - control auto reload component    
  */
  FormTitle: String = "Work With List Value";
  FormAccessRight: String = "NA";
  PrimaryApiPath: string = "api/BcpListValue/";
  UserProfileApiPath: string = "api/BcpUserProfile/";
  ListValueApiPath: string = "api/BcpListValue/";
  AuthApiPath: string = "api/BcpJwtAuth/getDistinguishedName/";

  ShowAddForm: Boolean = false;
  ShowEditForm: Boolean = false;
  SuccessUpload: Boolean = false;

  AutoReload: Boolean = true;

  scrollHeight: string = "";
  scrollWidth: string = "";

  public RecordCount: number = 0;

  httpOriginalUrl: String;
  stringifyValue = "";
  stringifyUploadValue = "";
  Headers = new HttpHeaders();
  isLoggedIn: boolean = false;

  //Attachment related
  public uploadAttachment: boolean = false;
  public record: any;
  uploadFile: File;
  AttachmentAutoReload: Boolean = true;

  public resultMsgs: Message[] = [];

  codeForm: Boolean = false;
  checkedError: string = "";
  newRecordId: any;

  //For display Edit and Delete Images
  //public imgEdit = require("../shared/Images/edit.gif");
  //public imgDelete = require("../shared/Images/delete.gif");

  //for animation status
  //animStatus: string = 'inactive';


  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string, private bcp: CommonSerivce, private datePipe: DatePipe, private confirmationService: ConfirmationService) {
    //  this.httpHeaders = this.bcp.getHttpHeader();
    this.PrimaryApiPath = originUrl + this.PrimaryApiPath;
    this.UserProfileApiPath = originUrl + this.UserProfileApiPath;
    this.ListValueApiPath = originUrl + this.ListValueApiPath;
    this.FormAccessRight = this.bcp.getAccessRightByProcess('LIST_VALUE');
    this.isLoggedIn = this.bcp.getLoginStatus();

    this.loggedInUserAccountType = this.bcp.getCurrentUserAccountType();
    this.loggedInCompanyCode = this.bcp.getCurrentCompanyCode();

    this.getListValue();
    //this.getData();

    //get all list value for drop down list
    this.getDomainList();
    this.getListCodeList();

    this.resetSearchField();
    this.FormTitle = "Work With List Value";
    this.ShowAddForm = false;
    this.ShowEditForm = false;

    this.scrollHeight = this.bcp.getDataTableHeight(0);//parameter: # of rows used for header search field
    this.scrollWidth = this.bcp.getDataTableWidth();

    this.SelectedRecord = null;
    this.InputErrorMsg = [];


    this.cols = [
      { field: 'actions', header: 'Actions', width: '80', size: '5' },
      { field: 'id', header: 'ID', width: '80', size: '5' },
      { field: 'domainId', header: 'Domain ID', width: '80', size: '10' },
      { field: 'listCode', header: 'List Code', width: '150', size: '10' },
      { field: 'listValue', header: 'List Value', width: '100', size: '10' },
      { field: 'desc01', header: 'Description 1', width: '150', size: '10' },
      { field: 'desc02', header: 'Description 2', width: '150', size: '10' },
      { field: 'displaySequence', header: 'Sequence ', width: '80', size: '10' },
      { field: 'activeFlag', header: 'Active', width: '80', size: '10' },
    ];

    this.exportColumns = this.cols.map(col => ({ title: col.header, dataKey: col.field }));
    this.pdfColumns[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);

  }

  ngOnInit() {

    console.log("on init");

    FilterUtils['custom'] = (value, filter): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return parseInt(filter) > value;
    };

   }

  //-----------------------------------------------------------------------------
  //                            Fetch/ Search Data
  //-----------------------------------------------------------------------------


  //to get required code list from Web API
  getListValue() {
    //get list value for data role
    this.http.get(this.UserProfileApiPath + "GetDataRole", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DataRoleList = result;
      });
    //get list value for process role
    this.http.get(this.UserProfileApiPath + "GetProcessRole", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.ProcessRoleList = result;
      });
  }

  //get record for initial inquiry
  getData() {
    this.AutoReload = true;
    this.http.get(this.PrimaryApiPath + "GetListValueList/" + "BCP" + "/" + "BCP", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
        this.RecordCount = this.RecordList.length;
        //console.log(this.RecordList);

        if (this.RecordList.length > 0) {
          for (var i = 0; i < this.RecordList.length; i++) {
            this.applyGlobalFilter();
            //Stop Loading Icon when finish fetching last record
            if (i = this.RecordCount) {
              //this.AutoReload = false;
            }
          }
        } else {
          this.RecordList = null;
          this.AutoReload = false;
        }
      });

  }

  //get list code record
  getListCodeData() {
    this.codeForm = true;
    this.FormTitle = "Work With List Code";
    this.AutoReload = true;
    this.http.get(this.PrimaryApiPath + "GetListValueList/" + "BCP" + "/" + "BCP", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
        this.RecordCount = this.RecordList.length;
        //console.log(this.RecordList);

        if (this.RecordList.length > 0) {
          for (var i = 0; i < this.RecordList.length; i++) {
            this.applyGlobalFilter();
            //Stop Loading Icon when finish fetching last record
            if (i = this.RecordCount) {
              //this.AutoReload = false;
            }
          }
        } else {
          this.RecordList = null;
          this.AutoReload = false;
        }
      });

  }

  //get record by id and assign to selected record
  getDataById(id) {
    this.http.get(this.PrimaryApiPath + id, this.bcp.getHttpOptions())
      .subscribe((data: any) => {
        this.SelectedRecord = data;
        this.SelectedRecord.activeFlag = this.bcp.convertYesNoToBoolean(this.SelectedRecord.activeFlag);
      });

  }

  //get record by search field(s)
  getDataBySearchField() {
    this.stringifyValue = JSON.stringify(this.SearchFieldHolder);
    this.http.post(this.PrimaryApiPath + "q", this.stringifyValue, this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.RecordList = result;
      });

  }

  //Get record ID for re-direct to edit page when click 'Save and Upload' (For upload Attachment)
  getIDbyData() {
    this.http.post(this.PrimaryApiPath + "GetID/Sec/" + this.bcp.getCurrentDataRole(), this.stringifyValue, this.bcp.getHttpOptions())
      .map((response: Response) => response.json())
      .subscribe(data => {
        this.record = data;
        this.editRecord(this.record.id);
      });

  }

  exportExcel() {
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(this.RecordList);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, "primengTable");
    });

  }


  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
     FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });

  } 

  exportPdf() {
    const doc = new jsPDF({ orientation: "landscape" });
    var head = [];
    head[0] = Object.values(this.cols.map(e => Object.keys(e).map(k => e[k]))).map(item => item[0]);
    autoTable(doc, {
      headStyles: { fillColor: [0,0,0] },
      styles: { fillColor: [255, 255, 0] },
      columnStyles: { 0: { halign: 'center', fillColor: [0, 255, 0] }, 1: { halign: 'left', fillColor: [0, 255, 255] } },
      head: head,
      body: this.RecordList.map(e => Object.keys(e).map(k => e[k])),
      didDrawCell: (data) => {
        //console.log(data.column.index)
      },
    });
    doc.save('table.pdf');
  }

  findRecord() {
    this.RecordList = null;
    this.getDataBySearchField();
  }

  resetSearchField() {
    //dummy field, not use for searching
    this.SearchFieldHolder = JSON.parse('{"id": 0}');
    //set default value for all search fields
    //available field, please refer to the last part of [TableName]Controller.cs
    this.SearchFieldHolder["domainId"] = this.bcp.getCurrentDomainId();
    this.SearchFieldHolder["listCode"] = "";
  }

  clearGlobalFilter() {
    this.globalFilterValue1 = "";
    this.globalFilterValue2 = "";
    this.globalFilterValue3 = "";
  }

  applyGlobalFilter() {
    var element = document.getElementById('globalFilter1');
    var event = new Event('input');

    element = document.getElementById('globalFilter1');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter2');
    element.dispatchEvent(event);

    element = document.getElementById('globalFilter3');
    element.dispatchEvent(event);
  }


  //-----------------------------------------------------------------------------
  //                      Add/Edit/Save/Delete Records
  //-----------------------------------------------------------------------------


  addRecord() {
    //initialize the SelectedRecord as a new record, and assign default value as required
    this.SelectedRecord = null;
    this.SelectedRecord = JSON.parse('{"id": 0}');
    //set default value 
    this.SelectedRecord.domainId = "";
    if (this.codeForm) {
      this.SelectedRecord.domainId = "BCP";
    } else if (this.SearchFieldHolder.domainId.trim() != "") {
      this.SelectedRecord.domainId = this.SearchFieldHolder.domainId;
    }
    this.SelectedRecord.listCode = "";
    if (this.codeForm) {
      this.SelectedRecord.listCode = "BCP";
    } else if (this.SearchFieldHolder.listCode.trim() != "") {
      this.SelectedRecord.listCode = this.SearchFieldHolder.listCode;
    }
    this.SelectedRecord.listValue = "";
    this.SelectedRecord.desc01 = "";
    this.SelectedRecord.desc02 = "";
    this.SelectedRecord.activeFlag = "Y";
    this.SelectedRecord.displaySequence = 0;
    this.SelectedRecord.remarks = "";
    this.SelectedRecord.process = "";
    this.SelectedRecord.controlFlag01 = "";
    this.SelectedRecord.controlFlag02 = "";
    this.SelectedRecord.controlFlag03 = "";
    this.SelectedRecord.createUser = this.bcp.getCurrentLoginUser();
    this.SelectedRecord.createDate = this.bcp.getCurrentDateTime();
    this.SelectedRecord.updateUser = "";
    this.SelectedRecord.updateDate = "";

    this.SelectedRecord.activeFlag = this.bcp.convertYesNoToBoolean(this.SelectedRecord.activeFlag);

    this.FormTitle = "List Value Revision";
    this.ShowAddForm = true;
    this.ShowEditForm = false;
  }

  editRecord(recordId) {
    this.SelectedRecord = null;
    this.getDataById(recordId);

    this.FormTitle = "List Value Revision";// - ID = " + recordId;
    this.ShowAddForm = false;
    this.ShowEditForm = true;

  }

  saveRecord() {
    //convert check box field value from boolean to character
    this.SelectedRecord.activeFlag = this.bcp.convertBooleanToYesNo(this.SelectedRecord.activeFlag);
    //convert to upper character
    this.SelectedRecord.listCode = this.bcp.upper(this.SelectedRecord.listCode);
    this.SelectedRecord.listValue = this.bcp.upper(this.SelectedRecord.listValue);

    //this.SelectedRecord.updateDate = this.bcp.getCurrentDateTime();
    //this.SelectedRecord.updateUser = this.bcp.getCurrentLoginUser();

    this.stringifyValue = JSON.stringify(this.SelectedRecord);
    //alert(this.stringifyValue);
    if (this.SelectedRecord.id == 0) {
      this.http.post(this.PrimaryApiPath, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            this.ShowAddForm = false;
            this.ShowEditForm = false;
            if (this.codeForm) {
              this.getListCodeList();
              this.getListCodeData();
            } else {
              this.FormTitle = "Work With List Value";
              this.findRecord();
            }
          },
          (err) => {

            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }
          });

    }

    else {
      //console.log("ready to put  " + this.stringifyValue);
      this.http.put(this.PrimaryApiPath + "" + this.SelectedRecord.id, this.stringifyValue, this.bcp.getHttpOptions())
        .subscribe(
          (result: any) => {
            this.ShowAddForm = false;
            this.ShowEditForm = false;
            if (this.codeForm) {
              this.getListCodeList();
              this.getListCodeData();
            } else {
              this.FormTitle = "Work With List Value";
              this.findRecord();
            }
          },
          (err) => {
            if (err.status === 400) {
              // handle validation error
              let validationErrorDictionary = JSON.parse(err.text());
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  this.InputErrorMsg.push(validationErrorDictionary[fieldName]);
                }
              }
            } else {
              this.InputErrorMsg.push("something went wrong!");
            }

          });

    }

  }

  //Return to Inquiry Form
  saveThenFindRecord() {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to save this record?',
      accept: () => {
        //this.uploadAttachment = false;
        this.checkThenSave();
      },
      reject: () => {
        //Do Nothing
      }
    });

  }

  deleteRecord(pId, pLoginId) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to delete this contact?',
      accept: () => {
        this.http.delete(this.PrimaryApiPath + pId, this.bcp.getHttpOptions())
          .subscribe(
            (data: any) => {
              this.findRecord();
            });

      },

      reject: () => {
        //Do Nothing
      }

    });

  }

  cancel() {
    if (this.codeForm) {
      this.getListCodeData();
    } else {
      this.FormTitle = "Work With List Value";
      this.findRecord();
    }
    this.SelectedRecord = null;
    this.InputErrorMsg = [];

    this.ShowAddForm = false;
    this.ShowEditForm = false;
  }

  resetListForm() {
    this.codeForm = false;
    this.RecordList = null;
    this.resetSearchField();
    this.FormTitle = "Work With List Value";
  }

  //-----------------------------------------------------------------------------
  //                      Fetch List Data for Drop Down List
  //-----------------------------------------------------------------------------

  getDomainList() {
    this.http.get("api/BcpDomain/DomainList", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.DomainList = result;
      });
  }

  getListCodeList() {
    this.http.get(this.ListValueApiPath + "ByListCode4/" + "BCP" + "/" + "BCP", this.bcp.getHttpOptions())
      .subscribe((result: any[]) => {
        this.ListCodeList = result;
      });
  }

  //-----------------------------------------------------------------------------
  //                                  Export Data
  //-----------------------------------------------------------------------------

  async generateExcelReport() {
    let listValueRec: IListValue;
    let listValueList: IListValue[];

    let fileReader = new FileReader();
    let strLine: string;
    let timeStamp: string;
    const url = "https://sheetjs.com/data/executive.json";

    //get the master data
    listValueList = this.RecordList;
    timeStamp = this.bcp.convertDateToString(null, true).toString();

    //initial the worksheet and workbook
    //this.strLine = "";
    //this.updateExcelRow();
    let worksheet = XLSX.utils.json_to_sheet(this.excelRow, { header: [""], skipHeader: true });
    let workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "ListValueReport");

    //if then else for easy to collapase the contents only
    //Header Fields
    if (1 == 1) {
      //---------------------------------------------
      //List Headings
      //---------------------------------------------
      if (this.FormAccessRight == "RW") {
        this.strLine = "Domain~ List Code~ List Value~ Description 1";
        this.strLine = this.strLine + "~ Description 2~ Active";
      } else {
        this.strLine = "List Code~ List Value~ Description 1";
        this.strLine = this.strLine + "~ Description 2~ Active";
      }

      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    //output the record details
    for (var i = 0; i < listValueList.length; i++) {

      if (this.FormAccessRight == "RW") {
        this.strLine = "" + listValueList[i].domainId
          + "~" + listValueList[i].listCode + "~" + listValueList[i].listValue
          + "~" + listValueList[i].desc01 + "~" + listValueList[i].desc02
          + "~" + listValueList[i].activeFlag;
      } else {
        this.strLine = "" + ""
          + "~" + listValueList[i].listCode + "~" + listValueList[i].listValue
          + "~" + listValueList[i].desc01 + "~" + listValueList[i].desc02
          + "~" + listValueList[i].activeFlag;
      }

      this.updateExcelRow();
      XLSX.utils.sheet_add_aoa(worksheet, [this.excelRow], { origin: -1 });
    }

    this.fixWidth(worksheet);
    this.applyCellFormat(worksheet);

    XLSX.writeFile(workbook, "ListValueList_" + timeStamp + ".xlsx", { compression: true });
  }

  updateExcelRow() {
    const colIndexArray = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    let dataArray: string[];
    this.excelRow = [];
    dataArray = this.strLine.split("~");
    //console.log("string is " + dataArray);
    for (let index = 0; index < dataArray.length; index += 1) {
      this.excelRow[index] = dataArray[index];
    }
  }

  //Formet Excel Cell
  fixWidth(worksheet: XLSX.WorkSheet) {
    const data = XLSX.utils.sheet_to_json<any>(worksheet)
    const wscols = [
      { width: 8 }, { width: 14 }, { width: 14 }, { width: 20 }, { width: 20 }, //ABCDE
      { width: 30 }, { width: 30 }, { width: 30 }, { width: 25 }, { width: 10 }, //FGHIJ
      { width: 20 }, { width: 15 }, { width: 20 }, { width: 20 }, { width: 20 }, //KLMNO
      { width: 20 }, { width: 15 }, { width: 15 }, { width: 15 }, { width: 15 }, //PQRST
      { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 } //UVWXYZ
    ];
    worksheet["!cols"] = wscols;

    this.lastRowNumber = data.length + 1;
  }

  applyCellFormat(worksheet: XLSX.WorkSheet) {

    //Format Cell as Bold with Border
    let tmpList = [];
    this.cellList = [];

    //bold
    this.addRangeToCellList("A", 1, "I", 1, true);
    this.formatCell(worksheet, this.cellList, "BOLD");

    //bgcolor
    this.addRangeToCellList("A", 1, "I", 1, true);
    this.formatCell(worksheet, this.cellList, "BGCOLOR_01");

    //border
    tmpList = [];
    this.addRangeToCellList("A", 1, "I", this.lastRowNumber, true);
    this.formatCell(worksheet, this.cellList, "BORDER");

    //amount with 2dp
    //aware if any space before the cell value
    tmpList = ["C5"];
    //this.formatCell(worksheet, this.cellList, "AMOUNT");

    //Number in 2dp
    tmpList = [""];
    //this.addListToCellList(tmpList, false);
    //this.formatCell(worksheet, this.cellList, "NUMBER");

    //percent in 2dp
    tmpList = [""];
    //this.formatCell(worksheet, this.cellList, "PERCENT");

    console.log(this.cellList);
  }

  addRangeToCellList(startCol, startRow, endCol, endRow, appendFlag) {
    let startColIndex = this.charToColIndex(startCol);
    let endColIndex = this.charToColIndex(endCol);
    let currCell: string;
    if (!appendFlag || this.cellList == null || this.cellList == undefined) {
      this.cellList = [];
    }

    for (let c = startColIndex; c <= endColIndex; c++) {
      for (let r = startRow; r <= endRow; r++) {
        this.cellList.push(this.colIndexToChar(c) + r);
      }

    }
  }

  formatCell(worksheet: XLSX.WorkSheet, localCellList: string[]
    , formatRule: string) {

    let defaultStyle = {
      font: {
        bold: false,
        italic: false,
        underline: false
      },
      border: {
        top: { style: "none", color: { auto: 1 } },
        right: { style: "none", color: { auto: 1 } },
        bottom: { style: "none", color: { auto: 1 } },
        left: { style: "none", color: { auto: 1 } }
      }
    };

    let newStyle = JSON.parse(JSON.stringify(defaultStyle));
    let originalStyle = JSON.parse(JSON.stringify(defaultStyle));

    const fontSetting01 = {
      bold: true,
      italic: false,
      underline: false
    };

    const borderSetting01 = {
      top: { style: "thin", color: { auto: 1 } },
      right: { style: "thin", color: { auto: 1 } },
      bottom: { style: "thin", color: { auto: 1 } },
      left: { style: "thin", color: { auto: 1 } }
    };

    const bgcolorSetting01 = {
      patternType: "solid",
      fgColor: { rgb: "e6f7eb" }
    }

    for (let i = 0; i < localCellList.length; i++) {
      //cache the original style of the cell

      if (worksheet[localCellList[i]] !== undefined) {
        if (formatRule === "BOLD" || formatRule === "BORDER"
          || formatRule === "BGCOLOR_01") {
          newStyle = JSON.parse(JSON.stringify(defaultStyle));
          originalStyle = JSON.parse(JSON.stringify(defaultStyle));
          if (worksheet[localCellList[i]].s !== undefined) {
            originalStyle = JSON.parse(JSON.stringify(worksheet[localCellList[i]].s));
          }

          if (originalStyle.font !== undefined) {
            newStyle.font = originalStyle.font;
          }
          if (originalStyle.border !== undefined) {
            newStyle.border = originalStyle.border;
          }
          if (originalStyle.fill !== undefined) {
            newStyle.fill = originalStyle.fill;
          }

          if (formatRule === "BOLD") {
            newStyle.font = fontSetting01;
          }

          if (formatRule === "BORDER") {
            newStyle.border = borderSetting01;
          }

          if (formatRule === "BGCOLOR_01") {
            newStyle.fill = bgcolorSetting01;
          }

          worksheet[localCellList[i]].s = newStyle;
        }

        if (formatRule === "AMOUNT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "_($* #,##0.00_);_($* (#,##0.00);_($* -??_);_(@_)";
        }

        if (formatRule === "NUMBER") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00";
        }

        if (formatRule === "NUMBER_4DP") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.0000";
        }

        if (formatRule === "PERCENT") {
          worksheet[localCellList[i]].t = "n"; //  change format
          worksheet[localCellList[i]].z = "0.00%";
        }
      } else {
        console.log("Error when Formatting Cell " + localCellList[i]);
      }
    }

  }
  //formatCell end

  charToColIndex(colName) {
    let result = 0;
    if (colName.length == 1) {
      result = colName.charCodeAt(0) - 64
    } else {
      result = (colName[0].charCodeAt(0) - 64) * 26;
      result = result + colName[1].charCodeAt(0) - 64;
    }
    return result;
  }

  colIndexToChar(colIndex) {
    let result: string = "";
    let adjustFlag = (colIndex - (Math.floor(colIndex / 26) * 26)) === 0 ? 1 : 0; // for AZ/BZ ... handling

    if (colIndex <= 26) {
      result = String.fromCharCode(colIndex + 64);
    } else {
      result = String.fromCharCode(Math.floor((colIndex - adjustFlag) / 26) + 64); //assume max column is ZZ
      result = result + String.fromCharCode(colIndex - (Math.floor((colIndex - adjustFlag) / 26) * 26) + 64);
    }
    return result;
  }




    //sorting event trigger, default is sorting by id
    changeSort(event) {
        if (!event.order) {
            this.sortF = 'id';
        } else {
            this.sortF = event.field;
        }
    }


  //-----------------------------------------------------------------------------
  //                      Checking/ Other Actions
  //-----------------------------------------------------------------------------

  clearAllMessage() {
    this.InputErrorMsg = [];
    this.resultMsgs = [];

  }

  async checkThenSave() {
    //Clear Search Form Error Message
    this.clearAllMessage();

    this.checkedError = 'N';
    //check domain
    if (this.SelectedRecord.domainId.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Domain field should not be null   ' });
    };
    //check list code
    if (this.SelectedRecord.listCode.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'List Code field should not be null   ' });
    } else if (this.SelectedRecord.id == 0 && this.bcp.upper(this.SelectedRecord.listCode) != "BCP") {
      this.newRecordId = 0;
      this.newRecordId = await this.http.get(this.PrimaryApiPath + "GetID/" + "BCP" + "/" + "BCP" + "/" + this.bcp.upper(this.SelectedRecord.listCode), this.bcp.getHttpOptions()).toPromise();
      if (this.newRecordId == 0) {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'List Code is not defined   ' });
      }
    };
    //check list value and duplication
    if (this.SelectedRecord.listValue.trim() == "") {
      this.checkedError = 'Y';
      this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'List Value field should not be null   ' });
    } else if (this.SelectedRecord.id == 0) {
      this.newRecordId = 0;
      this.newRecordId = await this.http.get(this.PrimaryApiPath + "GetID/" + this.SelectedRecord.domainId + "/" + this.bcp.upper(this.SelectedRecord.listCode) + "/" + this.bcp.upper(this.SelectedRecord.listValue), this.bcp.getHttpOptions()).toPromise();
      if (this.newRecordId > 0) {
        this.checkedError = 'Y';
        this.InputErrorMsg.push({ severity: 'error', summary: '[ Error Message ]', detail: 'Value is duplicated   ' });
      }
    };

    //save record if no error
    if (this.checkedError == 'N') {
      this.saveRecord();
    };
  };

}

interface IListValue {
  id?;
  domainId?;
  listCode?;
  listValue?;
  desc01?;
  desc02?;
  activeFlag?;
  displaySequence?;
  remarks?;
  process?;
  controlFlag01?;
  controlFlag02?;
  controlFlag03?;
  createUser?;
  createDate?;
  updateUser?;
  updateDate?;

}

interface IUserProfile {
  id?;
  domainId?;
  loginId?;
  password?;
  distinguishedName?;
  fullName?;
  department?;
  title?;
  email?;
  phone?;
  vip?;
  processRole?;
  dataRole?;
  activeFlag?;
  updateDate?;
  updateUser?;

}

interface IDataRole {
}

interface IProcessRole {
}

interface IListValue {
  label?;
  value?;
}


interface SelectItem {
}

interface Message {
}

interface IDomainValue {
  label?;
  value?;
}

interface ICodeValue {
  label?;
  value?;
}
